module.exports = __webpack_public_path__ + "img/line-levang-l.08a1f37e.webp";